export const isIos = () =>
  Boolean(
    window &&
      window.navigator &&
      /iP(ad|hone|od)/i.test(window.navigator.userAgent)
  )
